import Form from '@/found/components/form';
import request from '@/found/utils/request';
import { message } from 'ant-design-vue';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'add_form',
    };
  },
  props: {
    propsObj: Object,
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'amount') {
        console.log(v);
        v.props = {
          ...v.props,
          min: 0,
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      this.disabled(true, ['participatorType', 'participatorCode', 'participatorName']);
      this.setValue({
        ...this.propsObj.row,
      });
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        const url = '/cps/v1/redPacket/award/create';
        if (formData.amount <= 0) {
          message.error('金额必须大于0');
          return;
        }
        const params = {
          ...formData,
          type: 3,
        };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
